export const DEFAULT_UPDATING_MSG = '更新中'
export const DEFAULT_DOMAIN_NAME = 'qnqtree.com'
export const DEFAULT_DOMAIN_TITLE = 'QnQ'
export const DEFAULT_ROOT_MSG = '無題'
export const DEFAULT_ISSUE_LIMIT = 90
export const DEFAULT_CARD_LIMIT = 45



// WEBPACK FOOTER //
// ./src/constant/constant.js